<div class="flex items-start justify-between">

    <div class="flex items-center">

        <div class="text-xl font-medium tracking-tight leading-6 truncate"
             [style.color]="color"
        >
            {{batch}}</div>
        <mat-icon
                class="ml-1.5 icon-size-4 text-hint"
                [svgIcon]="'heroicons_solid:information-circle'"
                [matTooltip]="'La media non contempla le Application ricevute che non hanno indicato una valorizzazione'"></mat-icon>
    </div>

    <div class="flex items-center">
        <div class="rounded-full num-app-badge" [style.background-color]="color">
            {{data.totalApplicationWithPremoney}}
        </div>

    </div>
</div>
<div class="flex flex-col md:flex-row md:items-center mt-1">
    <div class="flex items-center mb-2 md_mb-0">
        <span [style.color]="color" class="text-xl font-semibold tracking-tight leading-tight">
           <span *ngIf="data && data.avgTotal"> € {{data?.avgTotal |  number: '1.0-0'}}</span>
           <span *ngIf="!data || !data.avgTotal"> - </span>
        </span>

    </div>
    <div class="flex flex-col flex-auto ml-8">
        <apx-chart
                class="flex-auto w-full h-20 md:h-16"
                [chart]="chartWeeklyExpenses?.chart"
                [colors]="chartWeeklyExpenses?.colors"
                [series]="chartWeeklyExpenses?.series"
                [stroke]="chartWeeklyExpenses?.stroke"
                [tooltip]="chartWeeklyExpenses?.tooltip"
                [xaxis]="chartWeeklyExpenses?.xaxis"
                [yaxis]="chartWeeklyExpenses?.yaxis"></apx-chart>
    </div>
</div>
